import { MarkovState } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { MarkovStateFilters } from "client/store"
import * as types from "./types"


export const setMarkovGroupStateList = (groupStateList: types.MarkovGroupStateList) => ({
    type: inferLiteral(types.MARKOV_GROUP_STATE_LIST),
    groupStateList,
})


export const setAssignedMarkovGroupStateIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_MARKOV_GROUP_STATE_IDS),
    stateIds,
})
export const setAssignedMarkovGroupStateSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_MARKOV_GROUP_STATE_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedMarkovGroupStateFilters = (filters: MarkovStateFilters) => ({
    type: inferLiteral(types.ASSIGNED_MARKOV_GROUP_STATE_FILTERS),
    filters,
})


export const setNotAssignedMarkovGroupStateIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_MARKOV_GROUP_STATE_IDS),
    stateIds,
})
export const setNotAssignedMarkovGroupStateSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_MARKOV_GROUP_STATE_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedMarkovGroupStateFilters = (filters: MarkovStateFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_MARKOV_GROUP_STATE_FILTERS),
    filters,
})
export const setNotAssignedMarkovGroupStateSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_MARKOV_GROUP_STATE_SELECTED),
    selected,
})


export const setMarkovGroupStateReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_GROUP_STATE_RELOAD_LIST),
    value,
})
